import React from 'react';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const isFirst = currentPage <= 0;
  const isLast = currentPage >= totalPages - 1;

  return (
    <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
      <button
        onClick={() => onPageChange(Math.max(0, currentPage - 1))}
        disabled={isFirst}
        style={{
          padding: '8px 16px',
          background: isFirst ? '#e2e8f0' : '#3182ce',
          color: isFirst ? '#a0aec0' : '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: isFirst ? 'not-allowed' : 'pointer',
          fontWeight: 600,
        }}
      >
        Previous
      </button>
      <span style={{ padding: '0 16px', fontWeight: 600 }}>
        Page {currentPage + 1} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages - 1, currentPage + 1))}
        disabled={isLast}
        style={{
          padding: '8px 16px',
          background: isLast ? '#e2e8f0' : '#3182ce',
          color: isLast ? '#a0aec0' : '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: isLast ? 'not-allowed' : 'pointer',
          fontWeight: 600,
        }}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;

